module.exports = __webpack_public_path__ + "d253e6b5cebea25625ad11c01ebdb867.MP3";